import React, { useState } from 'react'
import ZoneCsvParseButton from './ZoneCSVParseButton'
import ZoneEditableSpreadSheet from './ZoneEditableSpreadSheet';
import DataProvider from '../DataProvider';

const BulkUploadZones = (props) => {

    let [tableData, changeTableData] = useState([]);
    let [contactIds] = useState([]);

    const pBar = React.createRef()
    const pBarBG = React.createRef()

    function updateProgress(_progress) {
        try {
            pBar.current.style.width = _progress / tableData.length * 100 + "%"
            pBar.current.textContent = Math.round(_progress / tableData.length * 100) + "%"
        } catch (e) {
            console.log(e)
        }
    }

    const editTableData = (_editData) => {
        changeTableData(_editData)
        tableData = _editData
    }

    const submitData = async () => {
        try {
            pBar.current.style.display = 'inline-block'
            pBarBG.current.style.display = 'inline-block'
        } catch (e) {
            console.log(e)
        }

        let idx = 0
        for (const zone of tableData) {
            idx = idx + 1
            updateProgress(idx)
            await uploadZone(zone)
        }

        //confirm its done and ask to refresh the page
        try {
            pBar.current.style.display = 'none'
            pBarBG.current.style.display = 'none'
        } catch (e) {
            console.log(e)
        }
        alert('Upload Complete')
        window.location.reload()
    }

    function reformatZone(value) {
        if (!value) {
            console.error('Zone missing value')
            return false
        }
        const orgId = props.record.id
        const prefix = translateZone(value.message_prefix)
        if (!prefix) {
            console.error('Zone missing prefix')
            return false
        }
        value.message_prefix = prefix
        value.OrganizationId = orgId
        value.name = `Zone: ${value.customID}`
        value.message = autoFillMessage(prefix)
        return value
    }

    function autoFillMessage(prefix) {
        if (prefix === '*** THIS IS ONLY A TEST ***') return "-THIS IS ONLY A DRILL-"
        else if (prefix === '*** FALSE ALARM *** REPORTED') return "REQUEST FOR EMERGENCY ASSISTANCE HAS BEEN CANCELED  -  PLEASE INVESTIGATE"
        else if (prefix === 'ACTIVE THREAT ALERT REPORTED') return "REQUESTING IMMEDIATE POLICE ASSISTANCE"
        else if (prefix === 'DEVICE TAMPER ALERT - CHECK SECURITY SEAL') return "SECURITY SEAL HAS BEEN BROKEN - PLEASE INVESTIGATE"
        else if (prefix === 'SECURITY ALERT') return "REQUESTING IMMEDIATE SECURITY ASSISTANCE"
        else if (prefix === 'MEDICAL EMERGENCY REPORTED') return "REQUESTING IMMEDIATE MEDICAL ASSISTANCE"
        else if (prefix === 'EMERGENCY ALERT REPORTED') return ""
        return ""
    }

    function translateZone(message) {
        if (!message) {
            console.error('Zone missing message')
            return false
        }
        else if (message === 'TEST') return '*** THIS IS ONLY A TEST ***'
        else if (message === 'FALSE') return '*** FALSE ALARM *** REPORTED'
        else if (message === 'LPB' || message === 'SPB' || message === 'PP') return 'ACTIVE THREAT ALERT REPORTED'
        else if (message === 'PBC' || message === 'SBC' || message === 'TAMPER' || message === 'MBC') return 'DEVICE TAMPER ALERT - CHECK SECURITY SEAL'
        else if (message === 'LSB' || message === 'SSB' || message === 'SP') return 'SECURITY ALERT'
        else if (message === 'LMB' || message === 'SMB' || message === 'MP') return 'MEDICAL EMERGENCY REPORTED'
        else if (message === 'LHB' || message === 'HBC') return 'EMERGENCY ALERT REPORTED'
        else {
            console.error('Zone not translated', message)
            return false
        }
    }

    const uploadZone = async (value) => {
        const reformattedZone = reformatZone(value)
        if (!reformattedZone) {
            console.error('Zone not uploaded')
            return false
        }
        await DataProvider.create('zones', { data: reformattedZone })
    }
    return (<div ><ZoneCsvParseButton changeTableData={changeTableData} />
        <ZoneEditableSpreadSheet upload={submitData} tableData={tableData} changeTableData={(_editData) => editTableData(_editData)} pbarref={pBar} pbarbgref={pBarBG} />
    </div>

    )
}

export default BulkUploadZones